import { network } from 'services/network';

export const getVersion = () => {
    return network.get('admin/bo/getVersion').then((response) => response.data);
};
